import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Spinner from "components/ui/Spinner";

import "icons/clipboard-list.svg";
import alumLandingBg from "../assets/images/alum_landing_bg.png";
import calcentralLogoWhiteBg from "assets/images/calcentral_logo_whitebg.svg";
import { useCSRFToken } from "components/hooks/useCSRFToken";
import { ModernBlueButtonLink } from "components/ui/ButtonLink";

const defaultAlumData = {
  homepageLinkObj: {},
  landingPageMessage: "",
  landingPageSubTitle: "",
  skipLandingPage: false,
};

const AlumniOverlay = () => {
  const [errored, setErrored] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [alumData, setAlumData] = useState(defaultAlumData);
  const csrfToken = useCSRFToken();

  const httpHeaders = {
    "X-Requested-With": "XMLHttpRequest",
    "x-csrf-token": csrfToken,
  };

  const fetchData = () => {
    const url = "/api/alumni/alumni_profiles";
    fetch(url, { method: "GET" })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          setErrored(true);
          setIsLoaded(true);
        }
      })
      .then((data) => {
        setAlumData({
          homepageLinkObj: data.homepageLink,
          landingPageMessage: data.landingPageMessage.descrlong,
          landingPageSubTitle: data.landingPageSubTitle.descrlong,
          skipLandingPage: data.skipLandingPage,
        });

        if (data.skipLandingPage) {
          navigateToLandingPage(false, data.homepageLink.url);
        } else {
          setIsLoaded(true);
        }
      })
      .catch(() => {
        setErrored(true);
        setIsLoaded(true);
      });
  };

  const navigateToLandingPage = (saveDontShowAgain, homepageURL) => {
    const callLogout = fetch("/logout", {
      method: "POST",
      headers: httpHeaders,
    });
    let promiseList = [callLogout];
    if (saveDontShowAgain) {
      const setSkipFlag = fetch("/api/alumni/set_skip_landing_page", {
        method: "POST",
        headers: httpHeaders,
      });
      promiseList = [setSkipFlag, callLogout];
    }
    setIsLoaded(false);
    Promise.all(promiseList)
      .then((_res) => {
        window.location.href = homepageURL;
      })
      .catch((_err) => {
        setErrored(true);
        setIsLoaded(true);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    setDontShowAgain(e.target.checked);
  };

  const handleOnClick = () => {
    navigateToLandingPage(dontShowAgain, alumData.homepageLinkObj.url);
  };

  const landingPage = (
    <AlumniOverlayContainer data-testid="alumni-overlay-page">
      <div className="lightbox">
        <div className="overlay">
          {errored && (
            <>
              <img className="logo" src={calcentralLogoWhiteBg} />
              <p style={{ margin: "var(--lg)" }}>
                The Alumni Homepage is not available right now.
              </p>
            </>
          )}
          {!errored && !isLoaded && (
            <div className="spinnerSpacer">
              <Spinner />
            </div>
          )}
          {!errored && isLoaded && (
            <>
              <img className="logo" src={calcentralLogoWhiteBg} />
              <h2>{alumData.landingPageSubTitle}</h2>
              <div width="100%">
                <p className="messageText">{alumData.landingPageMessage}</p>
              </div>
              <br />
              <ModernBlueButtonLink
                title={alumData.homepageLinkObj.title}
                target="_self"
                className="cc-react-button cc-react-button--blue"
                onClick={handleOnClick}
              >
                {alumData.homepageLinkObj.name}
              </ModernBlueButtonLink>
              <p className="showCheck">
                <span className="showCheckbox">
                  <input
                    name="numberOfGuests"
                    type="checkbox"
                    value={dontShowAgain}
                    onChange={handleInputChange}
                  />
                </span>
                <span> Don&#39;t show me this again.</span>
              </p>
            </>
          )}
        </div>
      </div>
    </AlumniOverlayContainer>
  );

  return landingPage;
};

AlumniOverlay.displayName = "AlumniOverlay";
export default AlumniOverlay;

const AlumniOverlayContainer = styled.div`
  .lightbox {
    background: #4d6d8c;
    background-image: url("${alumLandingBg}");
    background-repeat: no-repeat;
    background-size: cover;
    position: fixed;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 0px;
    top: 0px;
    z-index: 100;
  }

  .spinnerSpacer {
    height: 100px;
    width: 300px;
    padding: 50px;
  }

  .messageText {
    font-size: 13px;
    text-align: center;
    padding-left: 30px;
    padding-right: 30px;
  }

  .logo {
    width: 200px;
    padding-top: 25px;
    padding-bottom: 25px;
  }

  .showCheck {
    margin-top: 20px;
    font-size: 13px;

    .showCheckbox {
      padding-top: 20px;
    }
  }

  .overlay {
    background: var(--white);
    width: 300px;
    border-radius: 5px;
    text-align: center;
  }
`;
